import { styled } from "@mui/system";

export const DialogContentContainer = styled("div")(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
}))

export const DialogContentItem = styled("div")(() => ({
  marginBottom: '1em'
}))